module.exports = __webpack_public_path__ + "img/percent_promo_icon.92775eeb.svg";